import Loadable from '../../components/loadable';

const ContactMessageSender = Loadable({
  loader: () => import('../../pages/messages/message_drawer'),
  type: 'drawer',
});

angular.module('shared').value('ContactMessageSender', ContactMessageSender);
